module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "describe"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("农业总产值")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("农业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("34.24 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
    staticClass: "percent"
  }, [_vm._v("5.60%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("牧业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("6.0151 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
    staticClass: "percent1"
  }, [_vm._v("-1.82%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("渔业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("1.342 "), _c('span', [_vm._v("亿元")])]), _vm._v(" "), _c('p', {
    staticClass: "percent1"
  }, [_vm._v("-18.83%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("生产规模")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("种植业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("79.2 "), _c('span', [_vm._v("万亩")])]), _vm._v(" "), _c('p', {
    staticClass: "percent"
  }, [_vm._v("6.80%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("畜牧业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("30.703"), _c('span', [_vm._v("万头")])]), _vm._v(" "), _c('p', {
    staticClass: "percent1"
  }, [_vm._v("-1.12%")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v("渔业")]), _vm._v(" "), _c('p', {
    staticClass: "num"
  }, [_vm._v("15840 "), _c('span', [_vm._v("吨")])]), _vm._v(" "), _c('p', {
    staticClass: "percent1"
  }, [_vm._v("-16.58%")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-005ac359!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/secondMap/center/centerTop/index.vue
// module id = 1914
// module chunks = 2